"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showEntityImportDialog = showEntityImportDialog;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const ImportProgress_1 = require("../components/ImportProgress");
const SelectFileArea_1 = require("../components/SelectFileArea");
function showEntityImportDialog(params) {
    (0, DialogHelper_1.showCustomDialog)({
        maxWidth: 'sm',
        fullWidth: true,
        content: (close, ariaLabelledBy, ariaDescribedBy) => (react_1.default.createElement(EntityImportDialogComponent, { ...params, close: close, ariaLabelledById: ariaLabelledBy, ariaDescribedById: ariaDescribedBy })),
    });
}
const EntityImportDialogComponent = (props) => {
    const [file, setFile] = react_1.default.useState();
    const handleImport = (file) => {
        (0, DialogHelper_1.showCustomDialog)({
            content: (close, ariaLabelledBy, ariaDescribedBy) => (react_1.default.createElement(ImportProgress_1.ImportProgress, { entity: props.entity, file: file, options: props.options, close: close, ariaLabelledById: ariaLabelledBy, ariaDescribedById: ariaDescribedBy })),
            fullWidth: true,
            maxWidth: 'sm',
        });
        props.close();
    };
    const handleRemoveFile = () => {
        setFile(undefined);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.DialogTitle, { id: props.ariaLabelledById }, props.options?.dialogTitle ?? 'Import'),
        react_1.default.createElement(material_1.DialogContent, { id: props.ariaDescribedById },
            props.options?.additionalDialogContent && react_1.default.createElement(material_1.Box, { pb: 2 }, props.options?.additionalDialogContent),
            react_1.default.createElement(SelectFileArea_1.SelectFileArea, { fileTypeLabel: 'CSV file', fileInputAccept: '.csv', file: file, onSelectFile: setFile, onRemoveFile: handleRemoveFile }),
            props.options?.csvTemplate && (react_1.default.createElement(material_1.Box, { pt: 1 },
                react_1.default.createElement(material_1.Typography, { variant: 'caption', sx: { color: JuvareTheme_1.themeColors.text.subtle } },
                    "Don't have the CSV template?\u00A0",
                    react_1.default.createElement(material_1.Link, { download: props.options.csvTemplateName ?? 'template.csv', href: `data:application/octet-stream,${encodeURIComponent(props.options?.csvTemplate)}`, "data-test": 'template-link' }, "Download"))))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => props.close(), "data-test": 'close-dialog-button' }, "Close"),
            file && (react_1.default.createElement(material_1.Button, { onClick: () => handleImport(file), "data-test": 'import-dialog-button' }, "Import")))));
};
